import axios from 'axios'

const metrics = {
  getDashboards() {
    return new Promise((resolve, reject) => {
      axios.get('/metrics/dashboards/')
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  createDashboard(data) {
    return new Promise((resolve, reject) => {
      axios.post('/metrics/dashboards/', data)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  updateDashboard(id, data) {
    return new Promise((resolve, reject) => {
      axios.patch(`/metrics/dashboards/${id}/`, data)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  getSettings() {
    return new Promise((resolve, reject) => {
      axios.get('/metrics/dashboard-settings/')
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  createSettings(data) {
    return new Promise((resolve, reject) => {
      axios.post('/metrics/dashboard-settings/', data)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  updateSettings(id, data) {
    return new Promise((resolve, reject) => {
      axios.patch(`/metrics/dashboard-settings/${id}/`, data)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  getFormStatus(template_ids) {
    return new Promise((resolve, reject) => {
      axios.post('/metrics/data/form_status/', { template_ids })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  getCaseProgress(case_type_id, checklist_items = []) {
    return new Promise((resolve, reject) => {
      axios.post('/metrics/data/case_progress/', { case_type_id, checklist_items })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  }
}

export default metrics
